@if (logo) {
<img
  alt="logo loader"
  fetchpriority="high"
  width="120px"
  class="center-logo logo-loader"
  [src]="logo"
/>
}
